<template>
  <div class="absolute inset-0 top-20">
    <div class="h-full">
      <activity-diagram
        :positioned="positionedData"
        :datas="datas"
        ref="diagram"
        @makereport="_makeReport"
      />
    </div>
  </div>
  <help :info="info" />
</template>

<script>
import globalMixins from "@/utils/mixins/mixin.js";

import Help from "@/components/Help.vue";
import ActivityDiagram from "@/components/MP/ActivityDiagram.vue";

export default {
  mixins: [globalMixins],

  components: { ActivityDiagram, Help },

  data() {
    return {
      editionActive: false,
      eltKey: 0,
      folders: null,

      meoList: [
        { id: 1, value: "Très Difficile" },
        { id: 2, value: "Difficile" },
        { id: 3, value: "Assez Difficile" },
        { id: 4, value: "Modéré" },
        { id: 5, value: "Facile" },
        { id: 6, value: "Très Facile" },
      ], // facilité de mise en oeuvre
      importanceList: [
        { id: 1, value: "Insignifiant" },
        { id: 2, value: "Faible" },
        { id: 3, value: "Modéré" },
        { id: 4, value: "Important" },
        { id: 5, value: "Substantiel / Majeur" },
        { id: 6, value: "Maximal" },
      ], // importance

      newElt: {
        id: "",
        value: "",
        importance: undefined,
        meo: undefined,
      },
      editedElt: {
        id: "",
        value: "",
        importance: undefined,
        meo: undefined,
      },

      positionedData: [[], [], [], [], [], []],

      colors: {
        lightYellow: "#ebcb8d",
        strongYellow: "#fcba03",
        lightGreen: "#57997a",
        strongGreen: "#0f631e",
        lightRed: "#c44d57",
        gray: "gray",
        white: "#fff",
        black: "#111",
      },

      dim: null, // Dimensions du conteneur du dessin
      ctx: null, // Contexte canvas
      size: null, // taille de la zone de dessin
      small: null, // Attribut small
      interval: null, // Interval entre les intersections
      rayon: null, // Rayon des activités
      maxNbrArray: [], // Nbre max d'activité pour les collisions
      maxNbr: 1, // Valeur max par défaut
      lightLine: 5, // Epaisseur d'une ligne mince
    };
  },
  methods: {
    async _makeReport() {
      this.generating = true;
      this.$swal.fire("Edition du rapport");
      this.$swal.showLoading();

      var pdfData = {
        module: this.currentModule,
        folder: this.currentFolder,
        file: this.currentFile,
        actors: window._.sortBy(this.datas, "name"),
        actorLabel: "Actions",
        actorKey: "name",
        identificationLabel: ["Action"],
        identificationKey: ["name"],
        titles: [
          "Identification des actions nécessaires à la mise en œuvre du projet",
          "Priorisation de chaque action identifiée en fonction de son importance et de la facilité de mise en œuvre.",
          "Visualisation de la matrice de priorisation des actions",
        ],
        categoriesLabel: [
          "Actions",
          "Importance",
          "Facilité de mise en oeuvre",
        ],
        categoriesKey: ["importance", "facility"],
        images: [
          /* { data: "", legend: "", title: "" } */
        ],
      };
      var im1 = await this.$refs.diagram.downloadImage();

      pdfData.images.push(im1);
      console.log(pdfData);
      this.$swal.hideLoading();

      this.$toast.fire({ title: "Le rapport a été edité", icon: "success" });
      this.makeReport(pdfData);
    },
  },
  created() {
    this.bValues = [
      {
        name: "Folders",
        uri: "/app/folders",
      },
      {
        name: "Files",
        uri: "/app/files",
      },
    ];
  },

  computed: {
    info() {
      return {
        name: this.currentModule?.name,
        description: this.currentModule?.moduleDescription,
      };
    },
  },
  async mounted() {
    this.folders =
      localStorage.getItem("temp-folder") !== null
        ? JSON.parse(localStorage.getItem("temp-folder"))
        : [];

    if (this.currentFile === null) this.datas = [];
    else {
      /* this.datas =
        localStorage.getItem(
          "temp-analyse-risques-" + this.currentFile.name
        ) !== null
          ? JSON.parse(
              localStorage.getItem(
                "temp-analyse-risques-" + this.currentFile.name
              )
            )
          : []; */
    }

    var response = await this.$axios.get(
      "/MatricePriorisationsQueries/GetMatricePriorisationAnalysis/" +
        this.currentFile.fileID
    );
    console.log(response.data);
    this.datas = response.data.map((x) => {
      var data = {
        ...x,
        name: x.activityName,
        importance: {
          ...this.importanceList.find((y) => x.importance == y.id),
        },
        facility: {
          ...this.meoList.find((y) => x.facility == y.id),
        },
      };
      this.positionedData[x.facility - 1][x.importance - 1] = [
        data,
        ...(this.positionedData[x.facility - 1][x.importance - 1] ?? []),
      ];
      return data;
    });
  },
};
</script>
<style lang="scss" scoped>
</style>
